import { memo, useCallback } from 'react';
import { BottomSheet, useNavigation } from '@betty/navigation';
import { Box, Button, Text } from '@betty/moonlight';
import { State, useDispatch, useSelector } from '@betty/toolkit/state';
import { abandonQuest, QuestsBottomSheetProps, selectQuest } from '../state';
import { useTranslation } from '@betty/i18n';

function AbandonQuestBottomSheet({ gameId, close }: QuestsBottomSheetProps) {
  const navigation = useNavigation();
  const { t } = useTranslation('quests');
  const dispatch = useDispatch();

  const activeQuest = useSelector((state: State) => selectQuest(state, gameId));

  const handleAbandon = useCallback(async () => {
    if (activeQuest) {
      try {
        await dispatch(abandonQuest(activeQuest.promotionId)).unwrap();
        close();
        navigation.goBack();
      } catch (_err) {
        BottomSheet.open({
          namespace: 'common',
          type: 'Info',
          data: {
            text: t('optOutErrMessage'),
          },
        });
      }
    }
  }, [activeQuest, dispatch, close, navigation, t]);

  if (!activeQuest) {
    return null;
  }

  return (
    <Box gap="space-400" marginTop="space-400">
      <Text
        variant="body-m-semi"
        locNS="quests"
        locKey="optOutOfQuestMessage"
        color="darkSurfacePrimary"
      />
      <Box flexDirection="row" gap="space-400" justifyContent="flex-end">
        <Button
          variant="secondary"
          onPress={() => close()}
          locNS="common"
          locKey="no"
          size="large"
        />
        <Button
          variant="primary"
          onPress={() => handleAbandon()}
          locNS="common"
          locKey="yes"
          size="large"
        />
      </Box>
    </Box>
  );
}

export default memo(AbandonQuestBottomSheet);
